import React, { useState, useEffect, useRef } from "react";
import AWS from "aws-sdk";
import defaultImage from "../../images/aaaaaa.png";
import { Spinner } from "react-bootstrap";
import emptyImage from "../../images/defaulImg.jpg";
import { FaPlay } from "react-icons/fa";

const S3Image = ({ imageKey, type, onRemove, fileType, style, large }) => {

  if (!imageKey && !type === "Profiles") {
    return (
      <div>
        <div className="video-player d-flex align-items-center justify-content-center">
          <Spinner animation="border" />
        </div>
      </div>
    );
  }

  return (
    <>
      {type === "Profiles" ? (
        <img
          height={45}
          width={45}
          src={imageKey ? imageKey : emptyImage}
          alt="image"
          className={style}
        />
      ) : (
        <div>
          {type === "edit-img" ? (
            <div className="image-picker position-relative">
              {fileType === "video" ? (
                <>
                  <video src={imageKey} />
                  <button className="remove-btn" onClick={onRemove}>
                    X
                  </button>
                </>
              ) : (
                <>
                  <img
                    src={imageKey}
                    alt="Selected"
                    className="preview-image"
                  />
                  <button className="remove-btn" onClick={onRemove}>
                    X
                  </button>
                </>
              )}
            </div>
          ) : (
            <div>
              <div className="reel-show-card">
                {fileType === "video" ? (
                  !large ? (
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <video
                        controls
                        muted
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                          display: "block",
                        }}
                        width="385"
                        height="400"
                      >
                        <source
                          src={imageKey}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          background: "rgba(0, 0, 0, 0.5)",
                          borderRadius: "50%",
                          padding: "15px",
                          cursor: "pointer",
                        }}
                      >
                        <FaPlay color="#fff" size={20} />
                      </div>
                    </div>
                  ) : (
                    <video
                      controls
                      autoPlay
                      muted
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                        display: "block",
                      }}
                      width="385"
                      height="300"
                    >
                      <source
                        src={imageKey}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  )
                ) : (
                  <img
                    className="video-player"
                    src={
                      imageKey
                        ? imageKey
                        : defaultImage
                    }
                  />
                )}
              </div>
              {type === "reel-img" && fileType !== "video" && (
                <img
                  className="video-player"
                  src={
                    imageKey
                      ? imageKey
                      : defaultImage
                  }
                />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default S3Image;
